<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
// Template SFC — PRESENTATION ONLY (DEV-1135 template purity contract).
defineProps<{
  quiz: {
    logo?: string;
    title?: string;
    sub_title?: string;
    legal_name?: string;
    legal_id?: string;
    disclaimer?: string;
    privacy_url?: string;
    privacy_text?: string;
  };
  progress: { current: number; total: number };
  canGoBack: boolean;
  showHero: boolean;
  isGate: boolean;
}>();
</script>

<template>
  <div class="tpl-ntc">
    <main class="tpl-ntc__main">
      <header class="tpl-ntc__header">
        <img v-if="quiz.logo" :src="quiz.logo" alt="logo" class="tpl-ntc__logo" />
      </header>

      <div v-if="showHero" class="tpl-ntc__hero">
        <h1 class="tpl-ntc__hero-title">{{ quiz.title }}</h1>
        <p v-if="quiz.sub_title" class="tpl-ntc__hero-sub">{{ quiz.sub_title }}</p>
      </div>

      <div class="tpl-ntc__stepper" aria-hidden="true">
        <span class="tpl-ntc__stepper-edge"></span>
        <template v-for="n in Math.max(progress.total, 1)" :key="n">
          <span
            class="tpl-ntc__stepper-node"
            :class="{ 'tpl-ntc__stepper-node--active': isGate || n <= progress.current }"
          ></span>
          <span class="tpl-ntc__stepper-edge"></span>
        </template>
      </div>

      <div class="tpl-ntc__card">
        <slot />
      </div>

      <footer class="tpl-ntc__footer">
        <p v-if="quiz.privacy_url">
          <a :href="quiz.privacy_url" target="_blank">{{ quiz.privacy_text || 'Privacy Policy' }}</a>
        </p>
        <p v-if="quiz.legal_name" class="tpl-ntc__footer-legal">
          {{ quiz.legal_name }}<template v-if="quiz.legal_id"> — {{ quiz.legal_id }}</template>
        </p>
        <p v-if="quiz.disclaimer" class="tpl-ntc__footer-disclaimer">{{ quiz.disclaimer }}</p>
      </footer>
    </main>
  </div>
</template>
